module.exports = __webpack_public_path__ + "static/media/sine-explorer-thumbnail.c3d3f896.png";